import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from 'src/app/core/services';

@Pipe({
  name: 'utils',
})
export class UtilsPipe implements PipeTransform {
  constructor(private utilsService: UtilsService) {}

  transform(value: any, fn: string, ...args: any[]): any {
    return this.utilsService[fn](value, ...args);
  }
}
